import { Link } from "react-router-dom";
import { useLang } from "../i18n";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const { t } = useLang();
  return (
    <div data-testid="payment-cancel-page" className="max-w-xl mx-auto px-6 py-24 text-center">
      <XCircle size={48} className="text-zinc-500 mx-auto mb-6" />
      <h1 className="text-3xl font-black tracking-tighter text-white mb-3">{t("cancel_title")}</h1>
      <p className="text-zinc-400 mb-8">{t("cancel_sub")}</p>
      <Link to="/descubrir" data-testid="cancel-back-link" className="text-emerald-400 font-semibold hover:text-emerald-300">
        {t("pay_back")}
      </Link>
    </div>
  );
}
